module.exports = __webpack_public_path__ + "static/media/great-reef.f5735654.gif";